import { useContext } from "react";
import { useForm } from "react-hook-form";
import Form from "../../components/inputs/form";
import Textbox from "../../components/inputs/textbox";
import Submit from "../../components/inputs/submit";
import ContactApi from "../../api/contact";
import AuthContext from "../../components/auth-context";
import useAppNavigate from "../../components/router/use-app-navigate";
import Checkbox from "../../components/search-filters/checkbox";
import { useParams } from "react-router-dom";
import Select from "../../components/inputs/select";
import { useState } from "react";

interface EditContactForm {
  firstName?: string;
  lastName?: string;
  title?: string;
  cellPhone?: string;
  IsSignatureOwner: boolean;
  isMale: boolean;
}

export default function EditContact() {
  const { register, handleSubmit, watch, setValue } =
    useForm<EditContactForm>();
  const navigate = useAppNavigate();
  const { id } = useParams<{ id: string }>();
  const context = useContext(AuthContext);
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const onSubmit = async ({
    firstName,
    lastName,
    cellPhone,
    title,
    IsSignatureOwner,
    isMale,
  }: EditContactForm) => {
    setIsSubmit(true);
    const api = new ContactApi(context);
    const { errorMessage } = await api.put({
      id: Number(id),
      firstName,
      lastName,
      cellPhone,
      title,
      IsSignatureOwner,
      isMale,
    });
   setIsSubmit(false);
    if (!errorMessage) navigate("/contacts");

    return errorMessage;
  };

  return (
    <Form submit={onSubmit} handleSubmit={handleSubmit}>
      <>
        <Select
          {...register("isMale", { required: true })}
          label="جنسیت"
          options={[
            { name: "خانم", value: "false" },
            { name: "آقای", value: "true" },
          ]}
        />
        <Textbox {...register("firstName")} label="نام" />
        <Textbox {...register("lastName")} label="نام خانوادگی" />
        <Textbox {...register("cellPhone")} label="شماره موبایل" />
        <Textbox {...register("title")} label="عنوان" />
        <Checkbox
          title="صاحب امضا"
          checked={watch("IsSignatureOwner")}
          onChange={(value) => setValue("IsSignatureOwner", value)}
        />
      </>
      <Submit loading={isSubmit} />
    </Form>
  );
}
